export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        {
            name: 'Content',
            children: [
                { name: 'Layouts', route: 'layouts', shortcut: 'layout/_' },
                { name: 'Pages', route: 'pages', type: 'page', shortcut: 'page/_' },
                { name: 'Panel library', route: 'panels', type: 'panel', shortcut: 'panel/_' },
                { name: 'Quick Links', route: 'quick_links', type: 'quick_link', shortcut: 'quick_link/_' },
                { name: 'Notifications', route: 'notifications', type: 'notification', shortcut: 'notification/_' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
        },
        {
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
            ...{ name: 'Assets', route: 'assets', type: 'asset' },
        },
        // {
        //     name: 'News',
        //     children: [
        //         { name: 'Posts', route: 'news_posts', type: 'news_post' },
        //         { name: 'Categories', route: 'news_categories', type: 'news_category' },
        //     ],
        //     iconClass: 'material-icons',
        //     iconName: 'perm_media',
        //     color: 'navy',
        // },
        // {
        //     iconClass: 'material-icons',
        //     iconName: 'video_library',
        //     color: 'navy',
        //     ...{ name: 'Videos', route: 'videos', type: 'video' },
        // },
        {
            name: 'Procedures',
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
            children: [
                { name: 'Procedures', route: 'procedures', type: 'procedure' },
                { name: 'Categories', route: 'categories', type: 'category' },
            ]
        },
        {
            name: 'Doctors',
            iconClass: 'material-icons',
            iconName: 'local_hospital',
            color: 'navy',
            children: [
                { name: 'Doctors', type: 'doctor', route: 'doctors' },
                { name: 'Specialties', type: 'specialty', route: 'specialties' },
            ],
        },
        {
            name: 'Testimonials',
            iconClass: 'material-icons',
            iconName: 'chat_bubble',
            color: 'navy',
            children: [
                { name: 'Testimonials', type: 'testimonial', route: 'testimonials' },
            ],
        },
        {
            iconClass: 'material-icons',
            iconName: 'assignment',
            color: 'navy',
            ...{ name: 'Applications', route: 'applications', type: 'application' },
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', shortcut: 'user/_', type: 'user' },
                { name: 'Roles', route: 'roles', shortcut: 'role/_', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        }
    ],
    defaultItem: 'Content',
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/menu.js